import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { OnDestroy } from '@angular/core';
import { Subject, Subscription, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { Router } from '@angular/router';
import { AuthConfigService } from '../auth-config/auth-config.service';
import { MsalService } from '@azure/msal-angular';
var TermsAndConditionsService = /** @class */ (function () {
    function TermsAndConditionsService(authService, http, router, msalService, authConfigService) {
        var _this = this;
        this.authService = authService;
        this.http = http;
        this.router = router;
        this.msalService = msalService;
        this.authConfigService = authConfigService;
        this._shown = new Subject();
        this.endpoint = 'terms-and-conditions';
        this.currentUser = null;
        this.userSubscription = authService.userInfoSubject.subscribe(function (u) {
            _this.currentUser = u;
            if (u && !u.hasAgreedToTermsAndConditions) {
                /* this.show();*/
                _this.router.navigate(['/terms-and-conditions']);
            }
        });
    }
    Object.defineProperty(TermsAndConditionsService.prototype, "canAgreeToTermsAndConditions", {
        get: function () {
            return !!this.currentUser
                && !this.currentUser.hasAgreedToTermsAndConditions
                && (this.currentUser.roles || []).length !== 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TermsAndConditionsService.prototype, "hasAgreedToTermsAndConditions", {
        get: function () {
            return !!this.currentUser
                && this.currentUser.hasAgreedToTermsAndConditions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TermsAndConditionsService.prototype, "shown", {
        get: function () {
            return this._shown;
        },
        enumerable: true,
        configurable: true
    });
    TermsAndConditionsService.prototype.ngOnDestroy = function () {
        if (this.userSubscription) {
            this.userSubscription.unsubscribe();
        }
    };
    TermsAndConditionsService.prototype.agree = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var request, result, error_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.http.post(this.endpoint, {}).pipe(catchError(function (error) {
                            if (error.status === 401) {
                                console.warn('T&C Agree: Received 401. Attempting full login redirect.');
                                // Instead of acquireTokenRedirect, trigger a full login flow
                                _this.authService.login();
                                // Return a subject that never completes because of redirect
                                return new Subject();
                            }
                            else {
                                // Re-throw other errors
                                return throwError(function () { return error; });
                            }
                        }));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 8]);
                        return [4 /*yield*/, request.toPromise()];
                    case 2:
                        result = _a.sent();
                        if (!(result !== undefined)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.authService.refresh()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [4 /*yield*/, Promise.resolve()];
                    case 5: return [2 /*return*/, _a.sent()];
                    case 6:
                        error_1 = _a.sent();
                        console.error("Error agreeing to T&C after potential token handling:", error_1);
                        return [4 /*yield*/, Promise.reject(error_1)];
                    case 7: return [2 /*return*/, _a.sent()];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    TermsAndConditionsService.prototype.show = function () {
        this._shown.next();
    };
    return TermsAndConditionsService;
}());
export { TermsAndConditionsService };
